import { useCallback } from "react";
function formatPriceWithoutCurrency(localeId, price) {
    const numberFormat = new Intl.NumberFormat(localeId, {});
    return numberFormat.format(price).toString();
}
function formatPriceWithCurrencyFallback(localeId, price, currency) {
    const formattedNumber = formatPriceWithoutCurrency(localeId, price);
    return `${formattedNumber}\u00A0${currency}`;
}
function formatPriceWithCurrency(localeId, price, currency) {
    const numberFormat = new Intl.NumberFormat(localeId, {
        style: "currency",
        currency: currency,
    });
    return numberFormat.format(price).toString();
}
function formatPrice(localeId, price, currency) {
    if (!currency) {
        return formatPriceWithoutCurrency(localeId, price);
    }
    try {
        return formatPriceWithCurrency(localeId, price, currency);
    }
    catch (err) {
        console.log(err);
        return formatPriceWithCurrencyFallback(localeId, price, currency);
    }
}
/**
 * @private Do not export or use in projects
 * @param localeId
 * @returns
 */
export function useDataTablePriceFormatter(localeId) {
    return useCallback((price, currency) => {
        return formatPrice(localeId, price, currency);
    }, [localeId]);
}
//# sourceMappingURL=useDataTablePriceFormatter.js.map